import { Consolidation } from '@returnmates/client-core/src/graphql/generated/api'
import moment from 'moment'

export const getFormattedData = (queryData: Consolidation[]): { [key: string]: string }[] =>
  // @ts-ignore
  queryData.map(data => ({
    ...data,
    date: data.createdAt ? moment.unix(data.createdAt).format('MM-DD-yyyy') : null,
    expectedDeliveryDate: data.expectedDeliveryDate
      ? moment(data.expectedDeliveryDate).format('MM-DD-yyyy')
      : null,
    destination: `${data.address?.city}, ${data.address?.street} `,
    name: data.address?.name,
    partnerName: data.partner?.name,
    carrierName: data.carrier?.name,
    locationName: data.locationName || '',
    hubOriginSortCode: data.hubOriginSortCode || '',
    hubDestinationSortCode: data.hubDestinationSortCode || '',
  }))
